
  <div class="col-md-12" style="background-color: white;display: inline-table;">
    <jul-alert [id]="alertId"></jul-alert>
    <form [formGroup]="impersonalizationPopupForm">

      <div class="row" style="padding: 30px 20px 0px 20px">
        <div class="col-md-10">
            <label class="impersonalization-change-profile-label">{{ 'impersonalization.label.change-profile' | translate }}</label>
        </div>
        <div class="col-md-2">
          <div dropdown #dropdown="bs-dropdown" [autoClose]="true" (isOpenChange)="onOpenChange($event)" class="dropdown-inline-container btn-group" (click)="preventClose($event)">
            <span class="filter">{{'generic.label.filter' | translate}}</span>
            <a href="javascript:void(0)" dropdownToggle> 
              <img src="assets/images/filter-25.svg">
            </a>
            
            <ul *dropdownMenu  class="dropdown-impersionalization dropdown-menu dropdown-filter dropdown-menu-right dropdown-menu--block" role="menu">
              <li role="menuItem">
                <div>
                  <jul-checkbox formControlName ="businessEntityInactive" style="display: inline-block; margin-right: 4rem;">
                    {{'impersonalization.filter.label.business-entity-inactive' | translate}}
                  </jul-checkbox> 
    
                  <jul-checkbox formControlName ="userInactive" style="display: inline-block">
                    {{'impersonalization.filter.label.user-inactive' | translate}}
                  </jul-checkbox> 
                </div>
              </li>
            </ul>
          </div>
          
        </div>
      </div>

      <div class="row impersonalization-main-row">

        <div class="col-md-6">

          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="text-style mb-4 mt-3"> {{ 'impersonalization.label.company' | translate }}</label>
                <jul-input
                  formControlName="searchBusinessEntity"
                  class="form-control"
                  placeholder="{{ 'impersonalization.placeholder.search-company' | translate }}"
                  type="text">
                </jul-input>
              </div>
            </div>
          </div>

          <div class="row impersonalization-height" [scrollWindow]="false" [fromRoot]="true" infiniteScroll (scrolled)="searchBusinessEntities()"
            [infiniteScrollDistance]="2" [infiniteScrollThrottle]="250">
            <jul-radiobutton-group formControlName="businessEntity">
                <div class="row" style="margin-bottom: -5px" *ngFor="let businessEntity of data?.results; let i = index">
                  <div class="col-md-12">
                    <div class="form-group">
                      <jul-radiobutton value="{{ businessEntity?.checked }}" (focus)="setCheckedBusinessEntity(i)">
                          {{ businessEntity?.docNumber }}, {{ businessEntity?.name | truncate:[30]}}
                      </jul-radiobutton>
                    </div>
                  </div>
                </div>
            </jul-radiobutton-group>
          </div>
        </div>

        <div class="col-md-6 border-left">

          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="text-style mb-4 mt-3"> {{ 'impersonalization.label.users' | translate }}</label>
                <jul-input
                  formControlName="searchUser"
                  class="form-control"
                  placeholder="{{ 'impersonalization.placeholder.search-user' | translate }}"
                  type="text">
                </jul-input>
              </div>
            </div>
          </div>

          <div class="row impersonalization-height" [scrollWindow]="false" [fromRoot]="true" infiniteScroll (scrolled)="searchUsers()"
          [infiniteScrollDistance]="2" [infiniteScrollThrottle]="250">
            <jul-radiobutton-group formControlName="user" style="width:100%">
                <div class="row" style="margin-bottom: -5px" *ngFor="let user of users?.results; let i = index">
                  <div class="col-md-12">
                    <div class="form-group">
                      <jul-radiobutton value="{{ user?.checked }}" (focus)="setCheckedUser(i)">
                          {{ user?.username }}
                      </jul-radiobutton>
                    </div>
                  </div>
                </div>
            </jul-radiobutton-group>
          </div>

        </div>

      </div>
      <ng-container *ngIf="mediaSize == 1">
          <div class="row" style="padding: 0px 20px 35px 20px">
            <div class="col-md-12">
                <a class="btn impersonalization-cancel-button float-left" (click)="cancel()">
                    {{ 'generic.button.cancel' | translate }}
                </a>
                <button type="submit" (click)="changeProfile()" class="btn impersonalization-add-button float-right" >
                    {{ 'impersonalization.button.change-profile' | translate }}
                </button>
            </div>
          </div>
      </ng-container>
      <ng-container *ngIf="mediaSize == 2">
          <div class="row" style="padding: 0px 20px 35px 20px">
              <div class="col-md-6 text-left">
                  <a class="btn impersonalization-cancel-button" (click)="cancel()">
                      {{ 'generic.button.cancel' | translate }}
                  </a>
              </div>
              <div class="col-md-6 text-right" style="padding-right: 28px;">
                  <button type="submit" class="btn impersonalization-add-button" (click)="changeProfile()" >
                      {{ 'impersonalization.button.change-profile' | translate }}
                  </button>
              </div>
          </div>
      </ng-container>
    </form>

</div>


